// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WeUnderstand_wrapper__q1HkC","logoWrapper":"WeUnderstand_logoWrapper__nwM1A","text":"WeUnderstand_text__gP47E","logo":"WeUnderstand_logo__D9Ge8"};